import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../messages';
import { useFeatureFlag } from '../../../feature-flags/hooks/use-feature-flag';
import { FeatureFlagDeclarations } from '../../../feature-flags/feature-flag-declarations';
import { usePatchedInventoryData } from './total-available';
import style from './style.module.less';
import { MDash } from 'ui-components/components/mdash';

const name = <FormattedMessage {...messages.stockColumnHeader} />;

const OnHandCell = (props) => {
  const { aggregateInventoryCounts, inventory, inventoryDisabled } = usePatchedInventoryData(props);
  const enableConsolidatedBundleData = useFeatureFlag(FeatureFlagDeclarations.enableConsolidatedBundleData);
  const stock = enableConsolidatedBundleData ? aggregateInventoryCounts?.onhandQuantity : inventory?.stock;
  return (
    <div className={style['right-align-column']}>
      {inventoryDisabled && <MDash />}
      {!inventoryDisabled && (stock ?? 0)}
    </div>
  );
};

export default {
  getMessageDescriptor: () => messages.stockColumnHeader,
  name,
  render: OnHandCell,
};
